export default "__VITE_ASSET__d8f3426a__"